import React from 'react';
import mermaid from 'mermaid';
// 로컬 컴포넌트 imports
import InlineCodeBlock from './InlineCodeBlock';
import MermaidCodeBlock from './MermaidCodeBlock';
import FullCodeBlock from './FullCodeBlock';
// Mermaid 초기화 (모듈 로드 시 한 번만 실행)
// 테마 'neutral'은 배경이 투명하므로, 필요 시 'default', 'dark', 'forest' 등으로 변경하거나
// MermaidContainer에서 배경색을 지정하세요.
mermaid.initialize({
    startOnLoad: false,
    theme: 'neutral'
});
/**
 * 커스텀 코드 블록 컴포넌트
 * 인라인 코드, Mermaid 다이어그램, 풀 코드 블록을 지원하는 통합 컴포넌트
 */ var CustomCodeBlock = function(param) {
    var className = param.className, children = param.children, inline = param.inline, node = param.node;
    // className에서 언어 추출 및 인라인 코드 여부 판별
    var match = /language-(\w+)/.exec(className || '');
    var language = (match === null || match === void 0 ? void 0 : match[1]) || 'text';
    // inline prop이 명시적으로 true거나, className에 language- prefix가 없으면 인라인 코드로 간주
    var isInlineCode = inline === true || !(className === null || className === void 0 ? void 0 : className.startsWith('language-'));
    // children을 문자열로 변환
    var codeString = React.Children.toArray(children).map(function(child) {
        return typeof child === 'string' ? child : '';
    }).join('').trim(); // 끝 공백 제거
    // 인라인 코드 처리
    if (isInlineCode) {
        return /*#__PURE__*/ React.createElement(InlineCodeBlock, {
            className: className
        }, children);
    }
    // Mermaid 다이어그램 처리
    if (language === 'mermaid') {
        if (!codeString) return null;
        return /*#__PURE__*/ React.createElement(MermaidCodeBlock, {
            codeString: codeString
        });
    }
    // 빈 코드 블록 처리
    if (!codeString) {
        return null;
    }
    // 풀 코드 블록 렌더링
    return /*#__PURE__*/ React.createElement(FullCodeBlock, {
        className: className,
        language: language,
        codeString: codeString
    });
};
export default CustomCodeBlock;
